// Cycle Market Direct - Bicycle Parts, Accessories & Supplies
// Brand operator: Arah Capital Group LLC

// ============================================
// SITE IMAGES - Cycling theme (stored locally, brand-free stock)
// ============================================
export const siteImages = {
  heroMain: '/banners/hero.jpg',
  heroSecondary: '/banners/promo-audio.jpg',
  heroLifestyle: '/banners/about.jpg',
  ctaBackground: '/banners/cta.jpg',
  featuredBackground: '/banners/cta.jpg',
  powerBackground: '/banners/promo-audio.jpg',
  shopBanner: '/banners/shop.jpg',
  aboutBanner: '/banners/about.jpg',
  contactBanner: '/banners/contact.jpg',
  returnsBanner: '/banners/shop.jpg',
  privacyBanner: '/banners/about.jpg',
};

export const SHIPPING_NOTICE = 'Free USPS shipping across the United States';
export const SHIPPING_COUNTRIES = ['US'];
export const SHIPPING_METHOD = 'USPS';
export const SHIPPING_TIME = '2-4 business days';
export const FREE_SHIPPING_THRESHOLD = 0; // Free shipping on all orders

export const CARD_DESCRIPTOR = '8775706567cyclemarketdirect';
export const HOSTING_PROVIDER = 'Hostinger';

export const CONTACT_INFO = {
  phone: '(877) 570-6567',
  email: 'contactus@cyclemarketdirect.com',
  corpName: 'Arah Capital Group LLC',
  address: {
    street: '1331 W HADDINGTON CT',
    city: 'PALATINE',
    state: 'IL',
    zip: '60067-6616',
    country: 'United States'
  }
};

// Return address must remain unchanged.
export const RETURN_ADDRESS = {
  street: '4711 34th St. N. Suite F',
  city: 'St. Petersburg',
  state: 'FL',
  zip: '33714',
  country: 'USA'
};

// ============================================
// BICYCLE SUPPLIES CATALOG (14 Products)
// Prices fixed to required processor MID points:
//   $9.63, $12.84, $19.26, $19.37, $28.89, $58.11, $77.48,
//   $142.16, $227.48, $318.72, $489.36, $612.44, $784.88, $999.00
// Product names, images and descriptions sourced from onlinesuppliesforbikes.com
// ============================================
export const products = [
  // ===== TOOLS & MAINTENANCE =====
  {
    id: "bike-multi-tool",
    name: "Bike Multi-Tool",
    slug: "bike-multi-tool",
    sku: "TSC-TLS-001",
    price: 9.63,
    image: "/products/bikes/multi-tool.jpg",
    badge: "Deal",
    categoryId: "tools-maintenance",
    categorySlug: "tools-maintenance",
    description: "A compact, pocket-sized multi-tool that packs the essentials for roadside fixes and trailside adjustments. Folding hex keys, screwdrivers and a chain breaker fold into a durable frame so you are never stranded by a loose bolt again.",
    keyBenefits: ["Folding hex keys and drivers", "Pocket-sized, lightweight build", "Handles roadside repairs anywhere"],
    usage: "Slip it in your jersey pocket or saddle bag, unfold the tool you need and tighten, adjust or fix on the go.",
    features: ["Multi-Function", "Chain Breaker", "Compact", "Steel Bits"],
    inStock: true
  },
  {
    id: "mini-bicycle-pump",
    name: "Mini Bicycle Pump",
    slug: "mini-bicycle-pump",
    sku: "TSC-TLS-002",
    price: 28.89,
    image: "/products/bikes/mini-pump.jpg",
    badge: "Best Value",
    categoryId: "tools-maintenance",
    categorySlug: "tools-maintenance",
    description: "This mini bicycle pump is a compact, lightweight solution for inflating your tires anywhere the ride takes you. A dual-valve head fits both Presta and Schrader, and the frame mount keeps it within reach for those unexpected flats.",
    keyBenefits: ["Fits Presta and Schrader valves", "Frame mount included", "High-pressure hand pump"],
    usage: "Clip it to your frame, attach the head to your valve and pump to pressure when a top-up is needed.",
    features: ["Dual Valve", "Frame Mount", "High PSI", "Alloy Body"],
    inStock: true
  },

  // ===== LIGHTS & SAFETY =====
  {
    id: "led-bike-wheel-lights",
    name: "LED Bike Wheel Lights",
    slug: "led-bike-wheel-lights",
    sku: "TSC-SAF-001",
    price: 12.84,
    image: "/products/bikes/wheel-lights.jpg",
    badge: "Popular",
    categoryId: "lights-safety",
    categorySlug: "lights-safety",
    description: "These LED bike wheel lights are designed to enhance visibility and add a striking, colorful glow to your ride after dark. Easy to install on your spokes, they keep you seen from the side while turning heads on the night streets.",
    keyBenefits: ["Bright side-visibility glow", "Tool-free spoke install", "Multiple lighting patterns"],
    usage: "Clip the lights onto your spokes, switch on your pattern and ride out visible from every angle.",
    features: ["Side Visibility", "Multi-Pattern", "Battery Powered", "Weatherproof"],
    inStock: true
  },
  {
    id: "bicycle-rear-view-mirror",
    name: "1 Pair Bicycle Rear View Mirror",
    slug: "bicycle-rear-view-mirror",
    sku: "TSC-SAF-002",
    price: 19.26,
    image: "/products/bikes/mirror.jpg",
    badge: "Best Seller",
    categoryId: "lights-safety",
    categorySlug: "lights-safety",
    description: "A pair of handlebar mirrors designed for enhanced rider safety and situational awareness. Wide-angle glass and a fully adjustable arm let you keep an eye on traffic behind you without breaking your line or your focus.",
    keyBenefits: ["Wide-angle rear visibility", "Fully adjustable arms", "Sold as a pair for both sides"],
    usage: "Mount to your handlebar ends, angle each mirror to your sightline and check traffic at a glance.",
    features: ["Pair", "Wide-Angle", "Adjustable", "Handlebar Fit"],
    inStock: true
  },
  {
    id: "bicycle-lock-with-alarm",
    name: "Bicycle Lock with Alarm",
    slug: "bicycle-lock-with-alarm",
    sku: "TSC-SAF-003",
    price: 142.16,
    image: "/products/bikes/lock.jpg",
    badge: "Pro Pick",
    categoryId: "lights-safety",
    categorySlug: "lights-safety",
    description: "Deter thieves with both physical resistance and a piercing 110dB alarm built right into the lock. Hardened construction resists cutting and prying, while the motion-triggered siren draws attention the moment someone tampers with your bike.",
    keyBenefits: ["Loud 110dB motion alarm", "Hardened cut-resistant body", "Rechargeable and weatherproof"],
    usage: "Lock your frame to a rack, arm the alarm and walk away knowing any tampering triggers the siren.",
    features: ["110dB Alarm", "Hardened", "Rechargeable", "Weatherproof"],
    inStock: true
  },
  {
    id: "smart-cycling-helmet",
    name: "Smart Cycling Helmet",
    slug: "smart-cycling-helmet",
    sku: "TSC-SAF-004",
    price: 318.72,
    image: "/products/bikes/helmet.jpg",
    badge: "Premium",
    categoryId: "lights-safety",
    categorySlug: "lights-safety",
    description: "This smart helmet is an advanced safety accessory built to keep cyclists protected and connected. Integrated turn signals, a brake light and Bluetooth alerts combine with a lightweight, well-ventilated shell for confident riding day or night.",
    keyBenefits: ["Integrated lights and turn signals", "Bluetooth safety alerts", "Lightweight, ventilated shell"],
    usage: "Charge the helmet, pair it over Bluetooth and use the remote to flash turn signals as you ride.",
    features: ["Turn Signals", "Brake Light", "Bluetooth", "Ventilated"],
    inStock: true
  },

  // ===== BAGS & CARRIERS =====
  {
    id: "water-bottle-holder",
    name: "Water Bottle Holder",
    slug: "water-bottle-holder",
    sku: "TSC-BAG-001",
    price: 19.37,
    image: "/products/bikes/bottle-holder.jpg",
    badge: "Deal",
    categoryId: "bags-carriers",
    categorySlug: "bags-carriers",
    description: "This water bottle holder is designed to securely cradle your bottle while you ride, so hydration is always within reach. Lightweight yet sturdy, it bolts to standard frame mounts and grips bottles firmly over rough terrain.",
    keyBenefits: ["Secure grip over rough roads", "Lightweight, sturdy cage", "Fits standard frame mounts"],
    usage: "Bolt the cage to your frame mounts, drop in your bottle and grab a drink one-handed on the move.",
    features: ["Lightweight", "Secure Grip", "Frame Mount", "Universal Fit"],
    inStock: true
  },
  {
    id: "front-bike-basket",
    name: "Urban Chic Front Bike Basket with Wooden Slats",
    slug: "front-bike-basket",
    sku: "TSC-BAG-002",
    price: 227.48,
    image: "/products/bikes/basket.jpg",
    badge: "New",
    categoryId: "bags-carriers",
    categorySlug: "bags-carriers",
    description: "Enhance the function and style of your bicycle with this Urban Chic front basket, finished with warm wooden slats. Roomy enough for groceries, bags or a small companion, it brings timeless commuter charm to any city ride.",
    keyBenefits: ["Roomy, everyday carrying space", "Stylish wooden-slat finish", "Easy handlebar mounting"],
    usage: "Mount the basket to your handlebars, load up your essentials and cruise into town in style.",
    features: ["Wooden Slats", "Handlebar Mount", "Spacious", "Commuter Style"],
    inStock: true
  },

  // ===== RIDE TECH & ELECTRONICS =====
  {
    id: "bluetooth-bike-speaker",
    name: "Bluetooth Bike Speaker",
    slug: "bluetooth-bike-speaker",
    sku: "TSC-TEC-001",
    price: 58.11,
    image: "/products/bikes/speaker.jpg",
    badge: "Popular",
    categoryId: "ride-tech",
    categorySlug: "ride-tech",
    description: "Bring your playlist along for the ride with this weather-resistant Bluetooth speaker built for handlebars. Clear, punchy sound and a rugged mount keep the music going through commutes and trails, rain or shine.",
    keyBenefits: ["Weather-resistant design", "Clear handlebar-mounted sound", "Long wireless battery life"],
    usage: "Clamp it to your bars, pair over Bluetooth and press play for a soundtrack on every ride.",
    features: ["Bluetooth", "Weatherproof", "Handlebar Mount", "Rechargeable"],
    inStock: true
  },
  {
    id: "wireless-bike-computer",
    name: "Wireless Bike Computer",
    slug: "wireless-bike-computer",
    sku: "TSC-TEC-002",
    price: 77.48,
    image: "/products/bikes/computer.jpg",
    badge: "Pro Pick",
    categoryId: "ride-tech",
    categorySlug: "ride-tech",
    description: "Track every metric that matters with this wireless cycling computer. A clean backlit display shows speed, distance, time and more at a glance, while the wireless sensor keeps your cockpit tidy and cable-free.",
    keyBenefits: ["Speed, distance and ride time", "Clean backlit display", "Wireless, cable-free sensor"],
    usage: "Fit the sensor and magnet, mount the head unit to your bars and watch your ride data update live.",
    features: ["Wireless", "Backlit", "Multi-Metric", "Easy Mount"],
    inStock: true
  },
  {
    id: "electric-bike-conversion-kit",
    name: "Electric Bike Conversion Kit",
    slug: "electric-bike-conversion-kit",
    sku: "TSC-TEC-003",
    price: 784.88,
    image: "/products/bikes/ebike-kit.jpg",
    badge: "Pro Kit",
    categoryId: "ride-tech",
    categorySlug: "ride-tech",
    description: "This electric bike conversion kit transforms your everyday bicycle into a powered e-bike. A hub motor, battery and controller give you a confident boost up hills and across long commutes, turning any ride into an effortless one.",
    keyBenefits: ["Adds electric assist to any bike", "Powerful hub-motor boost", "Long-range battery included"],
    usage: "Swap in the motorized wheel, mount the battery and controller, then twist and go with instant assist.",
    features: ["Hub Motor", "Battery Pack", "Controller", "DIY Install"],
    inStock: true
  },

  // ===== BIKES & BIG GEAR =====
  {
    id: "hitch-mount-bike-rack",
    name: "Lockable Hitch Mount Bike Rack for SUV & Truck",
    slug: "hitch-mount-bike-rack",
    sku: "TSC-BIG-001",
    price: 489.36,
    image: "/products/bikes/hitch-rack.jpg",
    badge: "Editor's Choice",
    categoryId: "bikes-big-gear",
    categorySlug: "bikes-big-gear",
    description: "Enhance your outdoor adventures with this Lockable Hitch Mount Bike Rack, a sturdy carrier for SUVs and trucks. Integrated locks secure both bikes and rack, while the tilting frame keeps your tailgate accessible on the road.",
    keyBenefits: ["Fits standard hitch receivers", "Integrated bike and rack locks", "Tilts for tailgate access"],
    usage: "Slide the rack into your hitch, load and strap your bikes, then lock it all down before you drive off.",
    features: ["Hitch Mount", "Lockable", "Tilting", "Heavy-Duty"],
    inStock: true
  },
  {
    id: "teen-bicycle",
    name: "Teen Bicycle",
    slug: "teen-bicycle",
    sku: "TSC-BIG-002",
    price: 612.44,
    image: "/products/bikes/teen-bike.jpg",
    badge: "Best Seller",
    categoryId: "bikes-big-gear",
    categorySlug: "bikes-big-gear",
    description: "A classic teen bicycle with a robust, sleek frame in a vibrant finish. Balanced geometry, reliable gearing and dependable brakes make it a confident everyday ride for school runs, weekend loops and growing riders.",
    keyBenefits: ["Balanced, confident geometry", "Reliable gearing and brakes", "Durable, good-looking frame"],
    usage: "Adjust the saddle to height, check the brakes and gears, then hop on and enjoy the ride.",
    features: ["Multi-Speed", "Alloy Frame", "Reliable Brakes", "All-Round"],
    inStock: true
  },
  {
    id: "kids-aluminum-bike",
    name: "Kids Bike with Aerospace Aluminum Frame",
    slug: "kids-aluminum-bike",
    sku: "TSC-BIG-003",
    price: 999.00,
    image: "/products/bikes/kids-bike.jpg",
    badge: "Flagship",
    categoryId: "bikes-big-gear",
    categorySlug: "bikes-big-gear",
    description: "Introduce your child to the joys of cycling with this bike crafted from lightweight aerospace-grade aluminum. The featherweight frame is easy to handle and built to last, giving young riders a safe, confident start on two wheels.",
    keyBenefits: ["Lightweight aerospace aluminum", "Easy for kids to handle", "Durable, safety-focused build"],
    usage: "Set the seat and bars to your child's size, add the training wheels if needed and let them roll.",
    features: ["Aluminum Frame", "Lightweight", "Kid-Sized", "Durable"],
    inStock: true
  },
];

export const categories = [
  {
    id: "bikes-big-gear",
    name: "Bikes & Big Gear",
    slug: "bikes-big-gear",
    description: "Complete bikes, racks and conversion-ready gear for every kind of rider",
    image: "/products/bikes/teen-bike.jpg",
    productCount: 3
  },
  {
    id: "lights-safety",
    name: "Lights & Safety",
    slug: "lights-safety",
    description: "Helmets, lights, mirrors and locks to keep you seen, secure and protected",
    image: "/products/bikes/helmet.jpg",
    productCount: 4
  },
  {
    id: "ride-tech",
    name: "Ride Tech & Electronics",
    slug: "ride-tech",
    description: "Bike computers, speakers and e-bike kits that upgrade every ride",
    image: "/products/bikes/computer.jpg",
    productCount: 3
  },
  {
    id: "tools-maintenance",
    name: "Tools & Maintenance",
    slug: "tools-maintenance",
    description: "Pumps, multi-tools and repair essentials to keep you rolling",
    image: "/products/bikes/mini-pump.jpg",
    productCount: 2
  },
  {
    id: "bags-carriers",
    name: "Bags & Carriers",
    slug: "bags-carriers",
    description: "Baskets, bottle cages and carriers to haul your essentials",
    image: "/products/bikes/basket.jpg",
    productCount: 2
  },
];

// ============================================
// FEATURES / WHY CHOOSE US
// ============================================
export const features = [
  { id: 1, title: 'Rider-Tested Gear', description: 'A tight, curated lineup of bike parts and accessories worth bolting on \u2014 no filler' },
  { id: 2, title: 'Free USA Shipping', description: 'Free USPS Standard Shipping on every order, no minimum required' },
  { id: 3, title: '30-Day Returns', description: 'Not the right fit? Send it back within 30 days, hassle-free' },
  { id: 4, title: 'Secure Checkout', description: 'Encrypted payments and privacy-first handling of your data' }
];

export const performanceBenefits = [
  { id: 1, title: 'Built to Ride', description: 'Every part is picked for real-world durability and performance' },
  { id: 2, title: 'Detail Obsessed', description: 'Precise fitment, clean finishes and dependable components throughout' },
  { id: 3, title: 'Rider Approved', description: 'Gear that keeps commuters, weekend warriors and racers rolling' },
  { id: 4, title: 'Fair, Honest Pricing', description: 'Straightforward prices on the bike gear you actually want' }
];

export const steps = [
  { id: 1, title: 'Browse', description: 'Explore our curated collection of bike parts, accessories and supplies.' },
  { id: 2, title: 'Choose', description: 'Pick the safety, tech, tools or carry gear that fits your ride.' },
  { id: 3, title: 'Checkout', description: 'Complete your order with fast, secure and encrypted payment.' },
  { id: 4, title: 'Ride', description: 'Bolt it on, roll out and get more from every mile.' }
];
